export function PageHero({
  eyebrow,
  title,
  intro,
  meta,
}: {
  eyebrow: string;
  title: string;
  intro?: string;
  meta?: string;
}) {
  return (
    <section className="public-page-hero">
      <div className="site-container py-16 lg:py-20">
        <p className="eyebrow text-teal-700">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-display text-[2.3rem] font-semibold leading-[1.08] tracking-tight text-ink sm:text-[3.2rem]">
          {title}
        </h1>
        {intro && (
          <p className="mt-5 max-w-2xl text-[1.1rem] leading-relaxed text-slate">
            {intro}
          </p>
        )}
        {meta && <p className="eyebrow mt-6 text-slate-light">{meta}</p>}
      </div>
    </section>
  );
}
